// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"15e68415","455":"f84dc751","977":"f1bc2711"}[chunkId] + ".chunk.js";
};